import { render } from "./Slogan7.vue?vue&type=template&id=4e9c21dc&scoped=true&lang=true"
import script from "./Slogan7.vue?vue&type=script&lang=js"
export * from "./Slogan7.vue?vue&type=script&lang=js"

import "./Slogan7.vue?vue&type=style&index=0&id=4e9c21dc&lang=css&scoped=true"

import exportComponent from "C:\\Users\\dev2\\Documents\\dev\\sitio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9c21dc"]])

export default __exports__